import React, { createContext, useState } from "react";
import Sound from "react-sound";
export const BuildingsContext = createContext({});




const BuildingsContextProvider = ({ children }) => {

  const [which, setWhich] = useState([])
  const [modalPage, setModalPage] = useState(1);
  const [width, setWidth] = useState(2400);
  const [height, setHeight] = useState(1810);
  const [bs, setBs] = useState(337);
  const [rangeValue, setRangeValue] = useState(0);
  const [autoPre, setAutoPre] = useState(false)
  const [checkShowing, setCheckShowing] = useState(false)
  const [page, setPage] = useState(0);
  const [speakVol, setSpeakVol] = useState(90)
  const [musicVol, setMusicVol] = useState(parseInt(40))
  const [isOn, setIsOn] = useState(false)
  const [playMusic, setPlayMusic] = useState(false);
  const [wycPage, setWycPage] = useState(0);
  const [pageRoad, setPageRoad] = useState(0);
  const [wycPlay, setWycPlay] = useState(Sound.status.PLAYING)
  const [wycStop, setWycStop] = useState(false)
  const [play, setPlay] = useState(true);
  const [modalPlaying, setModalPlaying] = useState(false)
  const [repeat, setRepeat] = useState(Sound.status.PLAYING);
  const [wlacz, setwlacz] = useState(true);
  const [wlaczOsad, setwlaczOsad] = useState(true);

  const [switchToEnglish, setSwitchToEnglish] = useState(false)

  return (
    <BuildingsContext.Provider
    value={{switchToEnglish, setSwitchToEnglish, wlaczOsad, setwlaczOsad, wlacz, setwlacz, repeat, setRepeat, modalPlaying, setModalPlaying, play, setPlay ,wycStop, setWycStop, pageRoad, setPageRoad, wycPlay, setWycPlay, playMusic, setPlayMusic, isOn, setIsOn, musicVol, setMusicVol, speakVol, setSpeakVol, checkShowing,page, setPage, setCheckShowing,which, setWhich, modalPage,setModalPage, width, setWidth, height, setHeight ,bs, setBs, rangeValue, setRangeValue, autoPre, setAutoPre, wycPage, setWycPage}}
    >
      {children}
    </BuildingsContext.Provider>
  )
}

export default BuildingsContextProvider;





// useEffect(() => {
//   const timer = setTimeout(() => {
//     document.getElementById("send").click();
//   }, 3000);
//   return () => clearTimeout(timer);
// }, []);